<xng-breadcrumb></xng-breadcrumb>
<div *ngIf="isLoading">
  <div *appSpinner="isLoading; message: 'Loading...'"></div>
</div>

<div class="container pt-4">
  <h4 class="orange" translate>filials.filials</h4>
  <div *ngIf="currentUser.role.name !== 'filialAdmin' && !isAllFilials" class="d-flex justify-content-end mb-3">
    <a [routerLink]="['new-filial']" class="custom_button" translate><i
        class='bx orange bx-plus mr-1'></i>filials.newFilial</a>
  </div>


  <div class="row mt-4">
    <app-search-input class="col-6" style="max-width: 300px; display: block;" [placeholder]="'global.searchByName' | translate"
      [searchControl]="searchControl"></app-search-input>
    <app-custom-select *ngIf="isAllFilials" style="max-width: 300px; display: block;" [options]="companies"
      (selectionChange)="onSelectionChange($event)"></app-custom-select>
  </div>

  <ng-template [ngIf]="!isAllFilials" [ngIfElse]="withPagination">
    <div *ngIf="filials && !filials.length" translate>filials.noFilials</div>

    <ng-container *ngIf="filials && filials.length">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-12" *ngFor="let filial of filials">
          <app-filial-item [filial]="filial" [currentUser]="currentUser" (onDelete)="onDelete($event)"></app-filial-item>
        </div>
      </div>
    </ng-container>
  </ng-template>
  <ng-template #withPagination>
    <div *ngIf="filials && !filials.filials.length" translate>filials.noFilials</div>
    <ng-container *ngIf="filials && filials.filials.length">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-12" *ngFor="let filial of filials.filials">
          <app-filial-item [filial]="filial" [currentUser]="currentUser" (onDelete)="onDelete($event)"></app-filial-item>
        </div>
      </div>
    </ng-container>
    <ngb-pagination [collectionSize]="filials?.totalCount" [(pageSize)]="perPage" [(page)]="page" [maxSize]="5"
      [rotate]="true" (pageChange)="jumpToPage($event)"></ngb-pagination>
  </ng-template>

</div>

<app-modal (close)="toggleDeleteFilial = !toggleDeleteFilial" *ngIf="toggleDeleteFilial">
  <div class="modal_container"
    style="text-align: initial; font-weight: 300 !important; letter-spacing: 1px; color: #15171a;">
    <div class="modal-header">
      <h4 class="modal-title" style="font-size: 1rem; font-weight: inherit;" translate
        [translateParams]="{name: filial.name}">global.deleteInfo</h4>
    </div>
    <div class="modal-body">
      <button class="custom_button" (click)="deleteFilial()" translate>global.yes</button>
      <button class="custom_button" (click)="toggleDeleteFilial = false;" translate>global.no</button>
    </div>
  </div>
</app-modal>